import React, { PureComponent } from 'react'

import HeaderBar from '../../Molecules/HeaderBar'
import MinimiseSidebarButton from './MinimiseSidebarButton'
import RoundSelectButton from './RoundSelectButton'
import Clock from './Clock'

import { translate } from '../../../services/translate'

export default class Header extends PureComponent {
  handleRoundSelect = (round) => {
    this.props.onRoundSelect(round)
  }

  render () {
    const { onMinimiseSidebar, sidebarMinimised, rounds, isWrapUp } = this.props
    const roundButtons = []
    if (rounds) {
      for (let r = 1; r <= rounds.count; r++) {
        let state = 'next'
        if (rounds.selected === r) {
          state = 'curr'
        } else if (r <= rounds.current) {
          state = 'prev'
        }
        roundButtons.push(
          <RoundSelectButton key={r} label={`${translate('general.roundButtons', 'Round')} ${r}`} state={state} round={r} onButtonPress={this.handleRoundSelect} />
        )
      }
      roundButtons.push(
        <RoundSelectButton key={rounds.count + 1} label={translate('general.wrapupButton', 'Wrap Up')} state={isWrapUp ? 'curr' : 'wrap'} round={rounds.count + 1} onButtonPress={this.handleRoundSelect} />
      )
    }
    return (
      <HeaderBar paddingMult={0}>
        <MinimiseSidebarButton onPress={onMinimiseSidebar} sidebarMinimised={sidebarMinimised} />
        {roundButtons}
        <Clock />
      </HeaderBar>
    )
  }
}
